const wConfig = window.globalConfig //在public/config.js配置
export default {
  ...wConfig,
}
